import { Injectable } from '@angular/core';
import { Lang, LANG, LangLocale } from './lang.types';
import { BehaviorSubject, Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LangService {
  private currentLangLocale$ = new BehaviorSubject<LangLocale>('en-US');

  setLang(langName: LangLocale) {
    this.currentLangLocale$.next(langName);
  }

  onLang(): Observable<{ lang: Lang; locale: LangLocale }> {
    return this.currentLangLocale$.pipe(
      map(locale => ({ lang: LANG[locale], locale })),
    );
  }

  getLang(langLocale: LangLocale): Lang {
    return LANG[langLocale];
  }

  get lang(): Lang {
    const currentLangLocale = this.currentLangLocale$.value;
    return this.getLang(currentLangLocale);
  }

  get locale(): LangLocale {
    return this.currentLangLocale$.value;
  }
}
